import {ICartItem, ICombineEngine} from "@app/shared";

export class Recap {
    private rooms: Array<RecapRoom> = [];
    private user = {};
    private card = {};

    /**
     * @param r RecapRoom
     * @returns Recap
     */
    public addRoom(r: RecapRoom) {
        this.rooms.push(r);
        return this;
    }

    /**
     * @returns Recap
     */
    public setUser(user) {
        this.user = user;
        return this;
    }

    public getUser() {
        return this.user;
    }

    /**
     * @returns Recap
     */
    public setCart(card) {
        this.card = card;
        return this;
    }

    getRooms() {
        return this.rooms;
    }

    toParams(): {rooms: any[], user: any, card: any} {
        return {
            rooms: this.getRooms().map((o: RecapRoom) => o.toObjet()), user: this.user, card: this.card
        };
    }
}

export class RecapRoom {
    idRoom: number;
    idLine: number;
    occupation: string;
    occupation_selected: string;
    indexSearch: string;
    idOffer: number;
    bed: Array<any>;
    keyBed: number;
    engineSelected: ICombineEngine;
    personnes: Array<any> = [];
    agesEnfants: Array<any> = [];
    index: string;
    newTitle: string;
    surface: string;

    constructor(item: ICartItem) {
        this.idRoom = item.idRoom;
        this.idLine = item.idLine;
        this.occupation = item.occupation;
        this.occupation_selected = item.occupation;
        this.indexSearch = item.indexSearch;
        this.idOffer = item.idOffer;
        this.bed = item.valbed;
        this.keyBed = parseInt(item.keybed);
        this.engineSelected = item.line.engineSelected;
        this.index = "index-".concat(Math.floor(Math.random() * 100000).toString());
        this.newTitle = item.newTitle;
        this.surface = item.surface;
    }
    public toObjet() {
        return {
            idRoom: this.idRoom,
            idLine: this.idLine,
            idOffer: this.idOffer,
            occupation: this.occupation,
            occupation_selected: this.occupation_selected,
            indexSearch: this.indexSearch,
            bed: this.bed,
            engineSelected: this.engineSelected.alias,
            personnes: this.personnes,
            agesEnfants: this.agesEnfants,
            newTitle : this.newTitle,
            surface : this.surface,
        };
    }
}